module.exports = __webpack_public_path__ + "static/media/loading_img.8dda6a9a.gif";